import { Model, Nullable } from '@/models/Model';
import { ProjectCourseFlagEnum } from './Flag';
import { Project } from './Project';
import { ApiFile } from './ApiFile';

export default interface Hackathon extends Model {
  edition: number;
  title: string;
  content: string;
  flagId: number;
  liveStreamUrl?: string;
  banner?: Nullable<ApiFile>;
}

export interface HackathonStage extends Model {
  hackathonId: number;
  startDate: string;
  endDate: string;
  type: StageTypeEnum;
}

export interface Winner extends Model {
  hackathonId: number;
  rank: number;
  category: ProjectCourseFlagEnum;
  project: Project;
}

export interface WinnerCreate extends Omit<Winner, 'project' | 'id'> {
  projectId: number;
}

export enum StageTypeEnum {
  SUBMISSION = 'SUBMISSION',
  INITIAL_VOTING = 'INITIAL_VOTING',
  FINAL_VOTING = 'FINAL_VOTING',
}
